'use strict';

require('../../style/');

require('./index.less');


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/lib/picker-view/style/index.js
// module id = 681
// module chunks = 0